// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import InternalChartFilter, { ChartFilterProps } from '../components/chart-filter/index.js';
export type InternalChartFilterProps<T> = ChartFilterProps<T>;
export { InternalChartFilter };
